// 1) Take control
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

function addProductTileClickListener() {
    $('.product-tile').on('click', function () {
        try {
            sessionStorage.setItem('scroll:' + location.pathname + location.search, window.scrollY);
        } catch (e) {
            sessionStorage.clear();
        }
    });
}

// 2) Save per-URL on navigate-away actions (clicks)
// 3) On pageshow, read & restore; re-try after DOM/content settles
window.addEventListener('pageshow', () => {
    const key = 'scroll:' + location.pathname + location.search;
    const y = sessionStorage.getItem(key);
    if (y && (y != 'undefined')) {
        const target = +y;
        const tryRestore = () => {
            const max = Math.max(0, document.documentElement.scrollHeight - innerHeight);
            scrollTo({ left: 0, top: Math.min(target, max) });
        };
        tryRestore();
        const t = setInterval(() => {
            tryRestore();
            if (Math.abs(scrollY - target) < 2) clearInterval(t);
        }, 1000);
    }

    $(document).on('plp-grid-update', function () {
        addProductTileClickListener();
    });

    addProductTileClickListener();
});
